import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { Row, TextButton, Typography } from 'seagull';
import { ChevronLeft } from 'seagull/icons';
import { getTestIds } from 'seagull/utils/TestIds';
import { useResponsive } from '~/client-flow/contexts';
import { useLocaleKeys } from '~/i18n';
import { getStepName, stepsTextsPath } from '../../../ClientOnboarding.utils';
import desktopStyles from '../../OnboardingPage/Steps/StepsContainer/StepsContainerDesktop.module.scss';
export const GetHeaderTID = (parentTestId)=>getTestIds({
        parentTestId
    });
export const Header = (param)=>{
    let { currentStep, relationship, onBack, testId } = param;
    const { isMobile } = useResponsive();
    const { HeaderTestIds } = useMemo(()=>GetHeaderTID(testId), [
        testId
    ]);
    const { t: stepsTexts } = useLocaleKeys(stepsTextsPath);
    const stepTitle = useMemo(()=>getStepName(currentStep, relationship, stepsTexts), [
        currentStep,
        relationship,
        stepsTexts
    ]);
    if (isMobile) {
        return /*#__PURE__*/ _jsx(Typography, {
            variant: "h3",
            weight: "normal",
            testId: HeaderTestIds.StepTitle(),
            children: stepTitle
        });
    }
    return /*#__PURE__*/ _jsx(Row, {
        className: desktopStyles.header,
        testId: HeaderTestIds.Root(),
        children: /*#__PURE__*/ _jsx(Row, {
            className: desktopStyles.headerContent,
            testId: HeaderTestIds.HeaderContent(),
            children: /*#__PURE__*/ _jsx(TextButton, {
                prefixIcon: /*#__PURE__*/ _jsx(ChevronLeft, {}),
                onClick: onBack,
                skin: "secondary",
                underline: "never",
                variant: "h4",
                weight: "normal",
                testId: HeaderTestIds.BackButton(),
                children: /*#__PURE__*/ _jsx("span", {
                    "data-testid": HeaderTestIds.StepTitle(),
                    children: stepTitle
                })
            })
        })
    });
};
